<template>
  <div class="destinations-container">
    <div class="row w-100 position-relative">
      <div class="d-flex align-items-center w-100 overflow-auto">
        <img
          src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Nos+destinations.jpg"
          alt="Destinations"
          class="img-destination pr-2"
        />

        <div class="d-flex flex-column justify-content-between align-items-start w-100 overflow-hidden" style="gap: 15px;">
          <span class="merriweather-bold-p16 pl-5">Nos destinations</span>

          <div class="destinations-scroll-wrapper position-relative px-4 w-100">
            <div
              class="scroll-arrow left-arrow"
              @click="scrollLeft"
            >
              <img src="../../images/arrow-left-black.svg" alt="Scroll Left" />
            </div>

            <div ref="scrollContainer" class="destinations-scroll d-flex align-items-start pl-4" style="gap: 30px;">
              <div
                v-for="(destination) in sortedDestinations"
                :key="destination.name"
                class="pr-3 border-right-desti"
              >
                <div class="raleway-bold-16 text-nowrap text-left pb-3 cursor-pointer no-translate"
                     @click="goToDestination(`/destination/${destination.slug}`)">
                  {{ destination.name }}
                </div>
                <div class="destination-section pr-4">
                  <div
                    class="raleway-medi-p15 text-nowrap text-left item-link"
                    v-for="region in destination.regions.filter(d => d.get_lodgings && d.get_lodgings.length > 0)"
                    :key="region.name"
                    @click="goToDestination(region.url || `/destination/${region.slug}`)"
                  >
                    {{ region.name }}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="scroll-arrow right-arrow"
              @click="scrollRight"
            >
              <img src="../../images/arrow-right-black.svg" alt="Scroll Right" />
            </div>
          </div>

          <div class="align-items-center all-destinations d-flex justify-content-center pt-4 destinations-scroll w-100">
            <a href="/destination" class="hortense-btn-primary raleway-bold-p" target="_blank">TOUTES NOS DESTINATIONS</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DestinationsList',
  props: {
    destinations: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      additionalRegions: [
        {
          name: 'Paris et ses environs',
          url: 'https://www.hortense.green/hebergements-moins-2h-paris',
          slug: 'paris-et-ses-environs',
          get_lodgings: [1]
        },
        {
          name: 'Lyon et ses environs',
          url: 'https://www.hortense.green/hebergements-moins-2h-lyon',
          slug: 'lyon-et-ses-environs',
          get_lodgings: [1]
        },
        {
          name: 'Bordeaux et ses environs',
          url: 'https://www.hortense.green/hebergements-moins-2h-bordeaux',
          slug: 'bordeaux-et-ses-environs',
          get_lodgings: [1]
        }
      ],
      additionalDestinations: [
        {
          name: 'Europe',
          slug: 'europe',
          regions: [
            {
              name: 'Italie',
              slug: 'italie',
              get_lodgings: [1]
            }
          ]
        }
      ]
    };
  },
  methods: {
    goToDestination(url) {
      window.open(url, '_blank');
    },
    scrollLeft() {
      this.$refs.scrollContainer.scrollBy({ left: -300, behavior: 'smooth' });
    },
    scrollRight() {
      this.$refs.scrollContainer.scrollBy({ left: 300, behavior: 'smooth' });
    }
  },
  computed: {
    sortedDestinations() {
      const order = ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE', 'EUROPE'];
      const destinations = this.destinations.map(d => ({
        regions: [...(d.regions || [])],
        ...d
      }));

      this.additionalDestinations.forEach((extraDestination) => {
        const exists = destinations.some(
          d => d.name && d.name.toUpperCase() === extraDestination.name.toUpperCase()
        );

        if (!exists) {
          destinations.push(extraDestination);
        }
      });
      
      // Find FRANCE destination and add additional regions at the first 3 positions (only if not already added)
      const franceDestination = destinations.find(d => d.name.toUpperCase() === 'FRANCE');
      if (franceDestination) {
        const existingNames = new Set(franceDestination.regions.map(r => r.name));
        const newRegions = this.additionalRegions.filter(r => !existingNames.has(r.name));
        franceDestination.regions = [...newRegions, ...franceDestination.regions];
      }

      const europeDestination = destinations.find(d => d.name.toUpperCase() === 'EUROPE');
      if (europeDestination) {
        const existingNames = new Set((europeDestination.regions || []).map(r => r.name));
        const italyRegion = {
          name: 'Italie',
          slug: 'italie',
          get_lodgings: [1]
        };

        europeDestination.regions = existingNames.has(italyRegion.name)
          ? europeDestination.regions
          : [italyRegion, ...(europeDestination.regions || [])];
      }
      
      return destinations.sort((a, b) => {
        const indexA = order.indexOf(a.name.toUpperCase());
        const indexB = order.indexOf(b.name.toUpperCase());

        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });
    }
  }
};
</script>

<style scoped>
.destinations-container {
  height: 450px;
  padding: 24px 5px 24px 32px;
  text-transform: capitalize;

  .img-destination {
    width: 200px;
    height: 342px;
    object-fit: cover;
  }

  .destination-section {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;

    .item-link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .border-right-desti {
    border-right: 1px solid #BFBFBF;
    align-self: stretch;
  }

  .border-right-desti:last-of-type {
    border-right: none;
  }

  .destinations-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }

  .scroll-arrow {
    position: absolute;
    top: 50%;
    width: 44px;
    height: 46px;
    border: 1px solid #f7f7f7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #F7F7F7;
    background-color: #f7f7f7;

    .left-arrow {
      left: 10px;
    }

    .right-arrow {
      right: 10px;
    }
  }

  .raleway-bold-16 {
    font-family: 'Raleway';
    font-weight: 700;
    font-size: 16px;
  }
}
</style>
